// extracted by mini-css-extract-plugin
export default {"deltavPage":"deltav-page_deltavPage__7Q6sf","images":"deltav-page_images__ThsUA","tables":"deltav-page_tables__+uFlU"};